"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('ON_SUBJECT_CONVERSATION_SELECTED_ACTION', function (conversationId) {
    return {
        conversationId: conversationId,
    };
});
//# sourceMappingURL=onSubjectConversationSelectedAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/actions/onSubjectConversationSelectedAction.js
// module id = 2049
// module chunks = 2 3 4 45 108